<div class="container-fluid mt-5">
  @if(barCharts?.graphicsByDays?.length == 0 && modeSelected == days){
    <div class="p-fluid grid">
      <div class="p-field col-12 mb-4 d-flex justify-content-center">
        <p-message severity="info" icon="pi pi-info-circle" text="{{ 'No Data Selected Dates' | translate: { maxDaysInGraphics: maxDaysInGraphics } }}"></p-message>
      </div>
    </div>
  }

  <div class="row justify-content-center my-1" *ngIf="barCharts?.graphicsByDays?.length != 0 || modeSelected != days">
    <div class="col-md-5 text-center">
      <h2 translate> Trend Overcomission </h2>
    </div>
    <div class="col-md-5 text-center customOffset">
      <h2 translate> Trend Number Tickets </h2>
    </div>
  </div>
  <div class="row vh-50 justify-content-center" *ngIf="barCharts?.graphicsByDays?.length != 0 || modeSelected != days">
    <div class="col-md-5 dashboard-content" >
      <ngx-charts-bar-vertical
        [results]="_aOvercommisionData"
        [scheme]="_aColorsData"
        [xAxis]="true"
        [yAxis]="true"
        [barPadding]="barPadding"
        [animations]="false"
        [showGridLines]="true"
        [showYAxisLabel]="true"
        [showXAxisLabel]="true"
        [yAxisTickFormatting]="formatY.bind(this)">
        <ng-template #tooltipTemplate let-model="model">
          <span class="tooltip-label">{{model.name}}</span>
          <span class="tooltip-val">{{formatNumber(model.value)}}</span>
        </ng-template>
      </ngx-charts-bar-vertical>
    </div>
    <div class="col-md-5 dashboard-content">
      <ngx-charts-bar-vertical
        [results]="_aNumDocData"
        [scheme]="_bColorsData"
        [xAxis]="true"
        [yAxis]="true"
        [barPadding]="barPadding"
        [animations]="false"
        [showGridLines]="true"
        [showYAxisLabel]="true"
        [showXAxisLabel]="true"
        [yAxisTickFormatting]="formatY.bind(this)">
        <ng-template #tooltipTemplate let-model="model">
          <span class="tooltip-label">{{model.name}}</span>
          <span class="tooltip-val">{{formatNumber(model.value)}}</span>
        </ng-template>
      </ngx-charts-bar-vertical>
    </div>
  </div>
  <div class ="row my-4">
      <div class="col-4">
        @if(this.modeSelected == this.days){
          <div class="row">
            <small translate [translateParams]="{ maxDaysInGraphics: maxDaysInGraphics }"> Display days </small>
          </div>
        }
        @if(this.modeSelected == this.months){
          <div class="row">
            <small translate [translateParams]="{ maxMonthsInGraphics: maxMonthsInGraphics }"> Display months </small>
          </div>
        }
      </div>
      <div class="col-4 text-center">
        <p-selectButton
            optionLabel="label"
            optionValue="value"
            optionDisabled="isDisabled"
            [(ngModel)]="modeSelected"
            [options]="timeOptions"
            (onChange)="getGraphics()"
        > </p-selectButton>
      </div>
  </div>
</div>
